<div class="container">
  <div class="loading-container" *ngIf="isLoading; else content">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Loading Parcels Data...</p>
  </div>
  <ng-template #content>
    <div class="top-controls">
      <div class="group1" [class.invisible]="!rowsDataSource.data.length">
        <span class="results-count">{{ rowsDataSource.data?.length }} Results</span>
        <app-column-selector
          matTooltip="Select Fields"
          [items]="columns"
          size="medium"
          (onSave)="onSaveColumns($event)"
        ></app-column-selector>
        <button mat-icon-button (click)="export()" matTooltip="Export to CSV" class="mx-2.5">
          <mat-icon>save_alt</mat-icon>
        </button>
      </div>
      <button matTooltip="Close" mat-icon-button (click)="close.emit()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
    <div class="table-container" *ngIf="rowsDataSource.data.length; else noRows">
      <table mat-table [dataSource]="rowsDataSource" matSort (matSortChange)="sortChange($event)" matSortDisableClear>
        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ getLabel(column) }}</th>
          <td mat-cell *matCellDef="let element">{{ getValue(element, column) }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (mouseover)="onHoverRow(row)"
          class="cursor-pointer"
        ></tr>
      </table>
    </div>
    <ng-template #noRows>
      <div class="no-rows">
        <p>No results to show</p>
      </div>
    </ng-template>
  </ng-template>
</div>
